import analytics from '../analytics'

export function userAddressServiceRetrieve (apiClient, userId, addressIndex, serviceYear) {
  const pathTemplate = '/service'
  const method = 'GET'
  const params = {}
  const additionalParams = {
    queryParams: {
      userId,
      addressIndex,
      serviceYear
    }
  }
  const body = {}

  console.log('Calling %s on %s', method, pathTemplate)
  var start = analytics.currentTime()
  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then((result) => {
      var end = analytics.currentTime()
      analytics.time('API', 'retrieve-service', end - start, 'success')
      return result.data
    })
    .catch((error) => {
      var end = analytics.currentTime()
      analytics.time('API', 'retrieve-service', end - start, 'error')
      throw error
    })
}

export function userAddressServiceUpdate (apiClient, userId, serviceInfo) {
  const pathTemplate = '/service'
  const method = 'POST'
  const params = {}
  const additionalParams = {}
  const body = serviceInfo

  // add the other necessary fields
  body.userId = userId

  console.log('Calling %s on %s', method, pathTemplate)
  var start = analytics.currentTime()
  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then((result) => {
      var end = analytics.currentTime()
      analytics.time('API', 'update-service', end - start, 'success')
      return result.data
    })
    .catch((error) => {
      var end = analytics.currentTime()
      analytics.time('API', 'update-service', end - start, 'error')
      console.log('Error retrieving service %j', error)
      throw error
    })
}



// WEBPACK FOOTER //
// ./src/api/service.js